function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-704.000000, -182.000000)",
  fill: "#2D3846"
}, React.createElement("g", {
  transform: "translate(703.000000, 181.000000)"
}, React.createElement("polygon", {
  points: "7.38 30.51 1.17 30.51 1.17 24.3"
}), React.createElement("polygon", {
  transform: "translate(16.695573, 14.985366) rotate(135.000000) translate(-16.695573, -14.985366) ",
  points: "2.05874329 10.5944205 31.3324026 10.5944205 31.3324026 19.3763113 2.05874329 19.3763113"
}), React.createElement("polygon", {
  points: "1.17 34.65 1.17 32.58 23.94 32.58 23.94 34.65"
}))));

const SvgEditBlackIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "30px",
  height: "34px",
  viewBox: "0 0 30 34",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEditBlackIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-black-icon.24a51cdf.svg";
export { ForwardRef as ReactComponent };